export const compareNumber = ascending => (a, b) => (ascending ? a - b : b - a);

export const compareString = ascending => (a, b) => {
    const first = a || '';
    const second = b || '';
    return (ascending ? first.localeCompare(second) : second.localeCompare(first));
};
